import { DATA_RECEIVED_STATUS } from './DataReceivedStatusSelect';

export const getNotSelectedValueLabel = ({
  isLoading, dataLength, label, noDataLabel,
}:{ isLoading?: boolean, dataLength?: number, label?: string, noDataLabel?: string }) => {
  if (isLoading) return 'Загрузка..';
  if (dataLength === 0) return noDataLabel || 'Нет данных';
  return label || 'Выберите..';
};
export const getDisabledSelect = ({ isLoading, dataLength }:{ isLoading?: boolean, dataLength?: number}) => {
  return dataLength === 0 || isLoading === true;
};

/** 
 * * 0 = неизвестно
 * * undefined = отсутствует фильтр
 */
export type SelectedBooleanStatusType = 0 | undefined | boolean;
export type SelectedDataReceivedStatusType = 0 | undefined | Omit<keyof typeof DATA_RECEIVED_STATUS, 'unknown'>
export type SelectedStormModeStatusType = 0 | undefined | 1 | 2
export type SelectedValue = string | boolean | 0 | undefined | number

/**
 * (Для выбора статусов) конвертирует строку выбранного значения из Select
 * и превращает в нормальное значение
 * */
export function convertSelectedValueForBoolean(value: string): SelectedBooleanStatusType {
  if (value === 'true') return true;
  if (value === 'false') return false;
  if (value === '0') return 0;
  if (value === '-1') return undefined;
  return undefined;
}

/**
 * * превращает `"-1"` в `undefined`;
 * * `"0"` превращает в число `0`
 * * `"true"` или `"false"` превращает в `true` или `false` соответсвенно
 * * число в виде строки превращает в число
 * */
export function convertSelectedValue(value: string): SelectedValue {
  if (value === '-1') return undefined;
  if (value === '0') return 0;
  if (value === 'true') return true;
  if (value === 'false') return false;
  if (/^\d+$/.test(value)) return +value;
  return value;
}
